module.exports = __webpack_public_path__ + "img/banner.de3332a7.jpg";